import Mock from '../mock'
import axios from 'axios.js'
import { getApiBaseUrl, getApiKey } from '../apiConfig'

const decodePayload = (payload) => {
    if (typeof payload === 'string') return payload
    if (payload instanceof ArrayBuffer) return new TextDecoder('utf-8').decode(new Uint8Array(payload))
    if (ArrayBuffer.isView(payload)) return new TextDecoder('utf-8').decode(payload)
    return ''
}

const parseErrorPayload = (payload, fallback) => {
    const text = decodePayload(payload)
    try {
        const parsed = JSON.parse(text)
        return parsed && typeof parsed === 'object' ? parsed : { error: 'Export Error', errorInfo: fallback }
    } catch (e) {
        return { error: 'Export Error', errorInfo: text || fallback, result: 'error' }
    }
}

Mock.onGet('/api/data-export/download').reply(async (config) => {
    const params = config?.params || {}
    const query = new URLSearchParams()
    query.set('apiKey', getApiKey())
    query.set('route', 'data-export/download/')
    query.set('type', String(params.type || ''))
    if (params.date_from) query.set('date_from', String(params.date_from))
    if (params.date_to) query.set('date_to', String(params.date_to))
    query.set('include_deleted', params.include_deleted ? '1' : '0')

    try {
        const response = await axios.get(`${getApiBaseUrl()}/?${query.toString()}`, {
            responseType: 'arraybuffer',
        })
        const contentType = String(response?.headers?.['content-type'] || '')
        if (!contentType.toLowerCase().includes('text/csv')) {
            return [400, parseErrorPayload(response?.data, 'Сервер не сформировал файл выгрузки')]
        }
        return [200, response.data, {
            'Content-Type': contentType,
            'Content-Disposition': response?.headers?.['content-disposition'] || '',
        }]
    } catch (e) {
        console.error('data export download error', e)
        return [Number(e?.response?.status) || 500, parseErrorPayload(e?.response?.data, 'Ошибка выгрузки данных')]
    }
})
